import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

/**
 * What every chat user could do before these became actions: they were the `export_chat_data`,
 * `share_chats` and `copy_chat_messages` features, on by default. Every built-in role bundles it
 * so releasing the gates takes nothing away.
 */
export const chatMessagingPolicy = defineBuiltinPolicy({
  key: 'builtin:chat-messaging',
  name: 'Chat Export, Share and Copy',
  description: 'Export chats and charts, share chats with other users, and copy chat messages.',
  actions: [
    PolicyActionEnum.ChatConversationExport,
    PolicyActionEnum.ChatConversationShare,
    PolicyActionEnum.ChatConversationCopy,
  ],
});
